<template>
  <div class="content">
    <div class="content-main">
      <p class="content-title">划卡推荐统计</p>
      <div class="content-input">
        <div class="content-input-item">
          <label>性别：</label>
          <el-select v-model="sex" placeholder="Select" style="width: 7em">
            <el-option v-for="item in sexArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>身份认证：</label>
          <el-select v-model="identityAuthState" placeholder="Select" style="width: 7em">
            <el-option v-for="item in identityAuthStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>学历认证：</label>
          <el-select v-model="eduAuthState" placeholder="Select" style="width: 7em">
            <el-option v-for="item in eduAuthStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>VIP：</label>
          <el-select v-model="vipState" placeholder="Select" style="width: 7em">
            <el-option v-for="item in vipStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
<!--        <div class="content-input-item">-->
<!--          <label>记录类型：</label>-->
<!--          <el-select v-model="type" placeholder="Select" style="width: 7em">-->
<!--            <el-option v-for="item in typeArray" :key="item.value" :label="item.label" :value="item.value">-->
<!--            </el-option>-->
<!--          </el-select>-->
<!--        </div>-->
        <div class="content-input-item">
          <DatePickerRange title="更新时间：" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
        </div>
        <div class="content-input-item">
          <SearchComponents :searchTypeList="searchTypeList" :searchType="searchType"  :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" />
          <el-checkbox v-model="limitState" style="margin-left: 8px;">有限制</el-checkbox>
        </div>
        <div class="content-input-item">
          <ElButtons type="primary" icon="search" @click="getPage(true)"> 查询 </ElButtons>
          <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
        </div>
      </div>
    </div>
    <div class="content-main">
      <div class="content-button">
        <div>
          <!--          <el-button type="primary" v-loading="updateLoading" @click="updateInteract">标为已审查</el-button>-->
        </div>
        <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
      </div>
      <div class="content-table">
        <el-table
            ref="multipleTableRef"
            :data="pageDataList"
            style="width: 100%"
            border
            @cell-click="toggleSelection"
            @selection-change="selsChange"
            @header-click="selsAll"
            v-loading="listLoading"
            @sort-change="sortChange"
        >
          <!--          <el-table-column type="selection" width="40" align="center" class-name="cursor"/>-->
          <el-table-column label="头像" v-if="checkColList.indexOf('头像') > -1" width="106">
            <template #default="scope">
              <el-image style="width: 80px; height: 80px" :src="scope.row.headImg.smallHeadImg" @click="showImg(scope.row)" class="cursor"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
            </template>
          </el-table-column>
          <el-table-column label="操作方" v-if="checkColList.indexOf('操作方') > -1" width="200">
            <template #default="scope">
              <UserInfoList :row="scope.row" showList="name,phone,uid,city,birth"/>
              <p>学历：<span v-if="scope.row.authEdu">{{scope.row.authEdu.education==1?'初中':scope.row.authEdu.education==2?'中专/职高/技校':scope.row.authEdu.education==3?'高中':scope.row.authEdu.education==4?'大专':scope.row.authEdu.education==5?'本科':scope.row.authEdu.education==6?'硕士':scope.row.authEdu.education==7?'博士':scope.row.authEdu.education==8?'博士后':''}}</span></p>
              <p>学校：<span v-if="scope.row.authEdu">{{scope.row.authEdu.schoolName}}</span></p>
              <p>学历认证：<span v-if="scope.row.authEdu">{{scope.row.authEdu.eduState == 2?'已认证':'未认证'}}</span></p>
              <p>身份认证：<span v-if="scope.row.identityAuth">{{scope.row.identityAuth.overallAuthState == 2?'已认证':'未认证'}}</span></p>
            </template>
          </el-table-column>
          <el-table-column property="statDate" label="时间" v-if="checkColList.indexOf('时间') > -1" width="120"/>
          <el-table-column property="" label="推荐操作记录" v-if="checkColList.indexOf('推荐操作记录') > -1" class-name="cursor" width="150">
            <template #default="scope">
              <p>推荐：<span style="color: #409eff">{{scope.row.loveNum + scope.row.skipNum}}</span></p>
              <p>心动：<span style="color: #409eff">{{scope.row.loveNum}}</span></p>
              <p>无感：<span style="color: #409eff">{{scope.row.skipNum}}</span></p>
              <p>心动率：<span style="color: #409eff" v-if="scope.row.loveNum + scope.row.skipNum > 0">{{ formatNumber(scope.row.loveNum/(scope.row.loveNum + scope.row.skipNum) * 100) }}%</span></p>
            </template>
          </el-table-column>
          <el-table-column property="" label="被推荐操作记录" v-if="checkColList.indexOf('被推荐操作记录') > -1" class-name="cursor" width="150">
            <template #default="scope">
              <p>被推荐：<span style="color: #409eff">{{scope.row.toLoveNum + scope.row.toSkipNum}}</span></p>
              <p>被心动：<span style="color: #409eff">{{scope.row.toLoveNum}}</span></p>
              <p>被无感：<span style="color: #409eff">{{scope.row.toSkipNum}}</span></p>
              <p>被心动率：<span style="color: #409eff" v-if="scope.row.toLoveNum + scope.row.toSkipNum > 0">{{ formatNumber(scope.row.toLoveNum/(scope.row.toLoveNum + scope.row.toSkipNum) * 100) }}%</span></p>
            </template>
          </el-table-column>
          <el-table-column property="loveNumSum" label="总心动率" v-if="checkColList.indexOf('总心动率') > -1" class-name="cursor" width="150" sortable='custom'>
            <template #default="scope">
              <p>推荐：<span style="color: #409eff">{{scope.row.loveNumSum + scope.row.skipNumSum}}</span></p>
              <p>心动：<span style="color: #409eff">{{scope.row.loveNumSum}}</span></p>
              <p>心动率：<span style="color: #409eff" v-if="scope.row.loveNumSum + scope.row.skipNumSum > 0">{{ formatNumber(scope.row.loveNumSum/(scope.row.loveNumSum + scope.row.skipNumSum) * 100) }}%</span></p>
            </template>
          </el-table-column>
          <el-table-column property="toLoveNumSum" label="总被心动率" v-if="checkColList.indexOf('总被心动率') > -1" class-name="cursor" width="150" sortable='custom'>
            <template #default="scope">
              <p>被推荐：<span style="color: #409eff">{{scope.row.toLoveNumSum + scope.row.toSkipNumSum}}</span></p>
              <p>被心动：<span style="color: #409eff">{{scope.row.toLoveNumSum}}</span></p>
              <p>被心动率：<span style="color: #409eff" v-if="scope.row.toLoveNumSum + scope.row.toSkipNumSum > 0">{{ formatNumber(scope.row.toLoveNumSum/(scope.row.toLoveNumSum + scope.row.toSkipNumSum) * 100) }}%</span></p>
            </template>
          </el-table-column>

          <el-table-column property="eachLoveNum" label="总互相心动" v-if="checkColList.indexOf('总互相心动') > -1" class-name="cursor" width="150" sortable='custom'>
            <template #default="scope">
              <p>数量：<span style="color: #409eff">{{scope.row.eachLoveNum}}</span></p>
            </template>
          </el-table-column>

          <el-table-column property="secretNum" label="总发送密信" v-if="checkColList.indexOf('总发送密信') > -1" class-name="cursor" width="150" sortable='custom'>
            <template #default="scope">
              <p>发送数量：<span style="color: #409eff">{{scope.row.secretNum}}</span></p>
              <p>被回复：<span style="color: #409eff">{{scope.row.toReplySecretNum}}</span></p>
              <p>被回复率：<span style="color: #409eff" v-if="scope.row.secretNum > 0">{{ formatNumber(scope.row.toReplySecretNum / scope.row.secretNum * 100) }}%</span></p>
            </template>
          </el-table-column>
          <el-table-column property="toSecretNum" label="总收到密信" v-if="checkColList.indexOf('总收到密信') > -1" class-name="cursor" width="150" sortable='custom'>
            <template #default="scope">
              <p>收到数量：<span style="color: #409eff">{{scope.row.toSecretNum}}</span></p>
              <p>回复：<span style="color: #409eff">{{scope.row.replySecretNum}}</span></p>
              <p>回复率：<span style="color: #409eff" v-if="scope.row.toSecretNum > 0">{{ formatNumber(scope.row.replySecretNum / scope.row.toSecretNum * 100) }}%</span></p>
            </template>
          </el-table-column>
          <el-table-column property="replySecretMatch" label="总密信匹配" v-if="checkColList.indexOf('总密信匹配') > -1" class-name="cursor" width="150" sortable='custom'>
            <template #default="scope">
              <p>数量：<span style="color: #409eff">{{scope.row.replySecretNum + scope.row.toReplySecretNum}}</span></p>
            </template>
          </el-table-column>
          <el-table-column property="userVisitNum" label="最近来访" v-if="checkColList.indexOf('最近来访') > -1" class-name="cursor" width="150" sortable='custom'>
            <template #default="scope">
              <p>数量：<span style="color: #409eff">{{scope.row.userVisitNum}}</span></p>
            </template>
          </el-table-column>
          <el-table-column property="" label="vip记录" v-if="checkColList.indexOf('vip记录') > -1" class-name="cursor" width="200">
            <template #default="scope">
              <UserVipLog :user-log-list="scope.row.vipDtList" />
            </template>
          </el-table-column>
          <el-table-column property="" label="金币记录" v-if="checkColList.indexOf('金币记录') > -1" class-name="cursor" width="200">
            <template #default="scope">
              <div v-for="(item, index) in scope.row.goldList" :key="index" style="margin: 8px 0;">
                <p>{{item.createTime}}</p>
<!--                <p>类型：{{item.type>0?'收入':item.type<0?'支出':'&#45;&#45;'}}</p>-->
                <p>{{item.typeName}}</p>
<!--                <p>任务：{{item.taskName}}</p>-->
<!--                <p>数量：{{item.num}}</p>-->
<!--                <p>账单名字：{{item.billName}}</p>-->
<!--                <p>操作后余额：{{item.balance}}</p>-->
              </div>
            </template>
          </el-table-column>
          <el-table-column label="用户日志" v-if="checkColList.indexOf('用户日志') > -1" class-name="cursor" width="200">
            <template #default="scope">
              <UserLog :user-log-list="scope.row.userLogList" />
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
        </el-pagination>

      </div>
    </div>
  </div>
</template>

<script>
import DatePickerRange from '../../components/DatePickerRange'
import SearchComponents from '../../components/SearchComponents'
import BtnGroup from '../../components/BtnGroup'
import { getRecommendStatPageList } from '../../api/url'
import {getFormData, postFormData} from '../../api/api'
import Dialog from '../../assets/js/dialog'
import UserLogDialog from '../../components/UserLog/UserLogDialog'
import ImgViewer from '../../assets/js/imageViewer'
import { common } from "@/assets/shared/select-constant";
import UserLog from "@/components/UserLog/UserLog";
import ipCityAbnormalDialog from '@/components/resume/ipCityAbnormalDialog'
import UserVipLog from "@/components/VipLog/UserVipLog";
import UserVipLogDialog from "@/components/VipLog/UserVipLogDialog";
import RecommendUserList from "@/views/data/components/RecommendUserList";
import EachLoveUserList from "@/views/data/components/EachLoveUserList";
import ChatSecretUserList from "@/views/data/components/ChatSecretUserList";
import UserVisitList from "@/views/data/components/UserVisitList";
import UserGoldList from "@/views/data/components/UserGoldList";

export default {
  name: "DataRecommend",
  components: { DatePickerRange, SearchComponents, BtnGroup, UserLog, UserVipLog },
  data() {
    return {

      sexArray: common.sexList,
      sex: common.sexList[0]['value'],

      identityAuthStateArray: [
        {label: '不限', value: -1},
        {label: '未认证', value: 1},
        {label: '已认证', value: 2},
      ],
      identityAuthState: -1,

      eduAuthStateArray: [
        {label: '不限', value: -1},
        {label: '未认证', value: 1},
        {label: '已认证', value: 2},
      ],
      eduAuthState: -1,

      vipStateArray: [
        {label: '不限', value: -1},
        {label: '未开通过', value: 1},
        {label: '生效中', value: 2},
        {label: '已过期', value: 3},
        {label: '终身vip', value: 4},
      ],
      vipState: -1,

      typeArray: [
        {label: '不限', value: -1},
        {label: '推荐', value: 1},
        {label: '被推荐', value: 2},
      ],
      type: -1,

      //注册/进入时间
      startTime: '',
      endTime: '',
      isChecked: false,

      //搜索
      searchTypeList: [
        {label : '手机号', value : 1},
        {label : '昵称', value : 2},
        {label : '用户ID', value : 3},
        {label : '用户日志', value : 4},
        {label : '身份证号', value : 5},
        {label : '实名', value : 6},
        {label : '自我介绍', value : 7},
      ],
      searchType: 1,
      searchValue: '',

      //刷新组
      colList: ['头像', '操作方', '时间', '推荐操作记录', '被推荐操作记录', '总心动率', '总被心动率', '总互相心动', '总发送密信', '总收到密信', '总密信匹配', '最近来访', 'vip记录', '金币记录', '用户日志'],
      checkColList: [],

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,

      dataSummary: [],
      summaryLoading: false,

      idArray: [],
      updateLoading: false,

      limitState: false,

      sort: 1,

    }
  },
  methods: {

    formatNumber(num) {
    // 判断是否为整数
    if (Number.isInteger(num)) {
      return num.toString(); // 如果是整数，直接转换为字符串
    } else {
      // 如果不是整数，保留两位小数并转换为字符串
      return num.toFixed(2);
    }
  },

    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
    },
    getCheck(val) {
      this.isChecked = val
    },
    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },
    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },
    // 重置参数
    refreshParam() {
      this.isChecked = false;
      this.sex = -1;
      this.sort = 1;
      this.vipState = -1;
      this.type = -1;
      this.identityAuthState = -1;
      this.eduAuthState = -1;
      this.searchValue = '';
      this.limitState = false;
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },
    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    //排序
    sortChange(column) {
      console.log(column)
      this.sort = 1
      if(column.prop == 'loveNumSum') {
        if(column.order == 'descending') {
          this.sort = 3;
        } else if(column.order == 'ascending') {
          this.sort = 4;
        }
      } else if(column.prop == 'toLoveNumSum') {
        if(column.order == 'descending') {
          this.sort = 5;
        } else if(column.order == 'ascending') {
          this.sort = 6;
        }
      } else if(column.prop == 'eachLoveNum') {
        if(column.order == 'descending') {
          this.sort = 7;
        } else if(column.order == 'ascending') {
          this.sort = 8;
        }
      } else if(column.prop == 'secretNum') {
        if(column.order == 'descending') {
          this.sort = 9;
        } else if(column.order == 'ascending') {
          this.sort = 10;
        }
      } else if(column.prop == 'toSecretNum') {
        if(column.order == 'descending') {
          this.sort = 11;
        } else if(column.order == 'ascending') {
          this.sort = 12;
        }
      } else if(column.prop == 'userVisitNum') {
        if(column.order == 'descending') {
          this.sort = 13;
        } else if(column.order == 'ascending') {
          this.sort = 14;
        }
      } else if(column.prop == 'replySecretMatch') {
        if(column.order == 'descending') {
          this.sort = 15;
        } else if(column.order == 'ascending') {
          this.sort = 16;
        }
      }
      this.getPage();
    },

    //获取选中id
    selsChange(sels) {
      this.idArray = sels.map(item => item.userId);
    },

    //全选
    selsAll(column, event) {
      if(column.type == 'selection') {
        let array = this.idArray;
        if(array.length == this.pageDataList.length) {
          array = [];
        }
        this.pageDataList.forEach(item => {
          if(array.indexOf(item.userId) === -1) {
            this.$refs.multipleTableRef.toggleRowSelection(item);
          }
        })
      }
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['sex'] = this.sex;
      param['sort'] = this.sort;
      param['vipState'] = this.vipState;
      param['type'] = this.type;
      param['identityAuthState'] = this.identityAuthState;
      param['eduAuthState'] = this.eduAuthState;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      param['searchType'] = this.searchType;
      param['searchValue'] = this.searchValue;
      param['limitState'] = this.limitState?1:0;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getRecommendStatPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    showImg(row) {
      let imgList = []
      imgList.push(row.headImg.headImg)
      ImgViewer.open({
        imgList: imgList
      })
    },

    toggleSelection(row, column, cell, event) {
      if(column.type == 'selection') {
        this.$refs.multipleTableRef.toggleRowSelection(row)
      }

      //更新用户日志
      if(column.label == '用户日志') {
        Dialog.open({
          title: '用户日志',
          component: UserLogDialog,
          data: {
            id: row.userId
          },
          close: () => {
            row['userLogList'] = JSON.parse(sessionStorage.getItem('userLog'));
          }
        })
      }

      //vip记录
      if(column.label == 'vip记录') {
        Dialog.open({
          title: 'vip记录',
          component: UserVipLogDialog,
          data: {
            id: row.userId
          },
          close: () => {

          }
        })
      }

      if(column.label == '推荐操作记录' || column.label == '被推荐操作记录' || column.label == '总心动率' || column.label == '总被心动率') {
        Dialog.open({
          title: column.label,
          component: RecommendUserList,
          data: {
            userId: row.userId,
            statDate: row.statDate,
            pageType: column.label == '推荐操作记录'?1:column.label == '被推荐操作记录'?2:column.label == '总心动率'?3:column.label == '总被心动率'?4:'',
            width: '1200px'
          }
        })
      }

      if(column.label == '总发送密信' || column.label == '总收到密信' || column.label == '总密信匹配') {
        Dialog.open({
          title: column.label,
          component: ChatSecretUserList,
          data: {
            userId: row.userId,
            pageType: column.label == '总发送密信'?1:column.label == '总收到密信'?2:column.label == '总密信匹配'?3:'',
            width: '1200px'
          }
        })
      }

      if(column.label == '总互相心动') {
        Dialog.open({
          title: column.label,
          component: EachLoveUserList,
          data: {
            userId: row.userId,
            width: '1200px'
          }
        })
      }

      if(column.label == '最近来访') {
        Dialog.open({
          title: column.label,
          component: UserVisitList,
          data: {
            userId: row.userId,
            width: '1200px'
          }
        })
      }

      if(column.label == '金币记录') {
        Dialog.open({
          title: column.label,
          component: UserGoldList,
          data: {
            userId: row.userId,
            width: '1200px'
          }
        })
      }



    },

    //用户异常ip列表
    openIpCityDialog(idx, row) {
      Dialog.open({
        title: '用户【' + row.nickName + '】异常ip列表',
        component: ipCityAbnormalDialog,
        data: {
          id: row.userId,
          width: '600px',
          ipState: row.ipState,
        },
        confirm: (result) => {
          this.pageDataList[idx]['ipState'] = result.state
        }
      })
    },



  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
  }
}
</script>

<style scoped>

</style>
